module.exports = __webpack_public_path__ + "static/img/7106_phase_function_Paper_Points.d084cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7106_phase_function_Paper_Points.png
// module id = g0Yh
// module chunks = 0